module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_danger.05325c61.gif";